import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import EmailVerified from "../modules/auth/EmailVerifed";
import EmailVerificationSent from "../modules/auth/EmailVerificationSent";
import ForgotPassword from "../modules/auth/forgot-password";
import Login from "../modules/auth/login/login";
import PasswordChanged from "../modules/auth/password-changed";
import PasswordEmailSent from "../modules/auth/password-email-sent";
import RegisterContactDetails from "../modules/auth/register-contact-details";
import RegisterDistributionDetails from "../modules/auth/register-distribution-details";
import ResetPassword from "../modules/auth/reset-password";
import Dashboard from "../modules/dashboard/dashboard";
import Signup from "../modules/auth/signup/signup";
import UploadDocumentDrugLicense from "../modules/auth/upload-document/uploadDocumentDrugLicense";
import UploadDocumentGST from "../modules/auth/upload-document/uploadDocumnetGST";
import PrivateRoute from "./privateRoute";
import ProtectedRoute from "./protectedRoute";
import EmailVerificationLink from "../modules/auth/emailVerificationLink";
import CurrentOrders from "../modules/current-orders/currentOrders";
import { ToastContainer } from "react-toastify";
import ErrorPage from "../404error";
import EmailVerificationFail from "../modules/auth/emailVerificationFail";
import { isOnboarding } from "./config";
import OnBoardingRoute from "./OnBoardingRoute";
import FAQ from "../modules/faq/faq";
import Support from "../modules/faq/support";
import Redirected from "../modules/redirected/Redirected";
import DistributorDetailsEdit from "../modules/current-orders/distributor-details-edit";
import UploadProfileImage from "../modules/auth/upload-document/uploadProfileImage";
import CreateNewPassword from "../modules/auth/login/createNewPassword";
import Notification from "../modules/notifications/notification";

const MainRoute = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/*" element={<ErrorPage />} />
          <Route path="/admin-login/:id" element={<Redirected />} />
          <Route element={<PrivateRoute />}>
            <Route
              path="/email-verification-send"
              element={<EmailVerificationSent />}
            />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/verified" element={<EmailVerified />} />
            <Route
              path="/email-verification-link/:id"
              element={<EmailVerificationLink />}
            />
            <Route
              path="/email-verification-fail"
              element={<EmailVerificationFail />}
            />
            <Route
              path="/create-new-password"
              element={<CreateNewPassword />}
            />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:id" element={<ResetPassword />} />
            <Route path="/password-changed" element={<PasswordChanged />} />
            <Route
              path="/password-change-email"
              element={<PasswordEmailSent />}
            />
          </Route>
          <Route element={<OnBoardingRoute />}>
            <Route
              path="/register-contact-details"
              element={<RegisterContactDetails />}
            />
            <Route
              path="/register-distribution-details"
              element={<RegisterDistributionDetails />}
            />
            <Route
              path="/upload-document-drug-license"
              element={<UploadDocumentDrugLicense />}
            />
            <Route
              path="/upload-document-gst"
              element={<UploadDocumentGST />}
            />
            <Route
              path="/upload-profile-image"
              element={<UploadProfileImage />}
            />
          </Route>

          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<CurrentOrders />} />
            <Route path="/current-orders" element={<CurrentOrders />} />
            <Route path="/orders-hostory" element={<CurrentOrders />} />
            <Route path="/supplied-order-cfa" element={<CurrentOrders />} />
            <Route
              path="/distributor-details-edit"
              element={<DistributorDetailsEdit />}
            />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/support" element={<Support />} />
            <Route path="/notification" element={<Notification />} />
          </Route>
        </Routes>
        <ToastContainer />
      </Router>
    </>
  );
};

export default MainRoute;
